// extracted by mini-css-extract-plugin
module.exports = {"TableAdmin":"styles_TableAdmin__3wj5v","tabContent":"styles_tabContent__3-Bnd","tabMyCoupon":"styles_tabMyCoupon__a61q_"};